import type {
  OpenAnswerQuestion,
  SingleAnswerQuestion,
  SingleAnswerQuestionOption,
} from '@feh/shared-ui';
import { createAction, props } from '@ngrx/store';

const prefix = '[HomebatteryQuestionnaire]';

export const submitQuestionnaireAnswer = createAction(
  `${prefix} Submit questionnaire answer`,
  props<{
    question: SingleAnswerQuestion | OpenAnswerQuestion;
    answer: SingleAnswerQuestionOption | number;
  }>()
);

export const initializeQuestionnaire = createAction(
  `${prefix} Initialize questionnaire`,
  props<{ useNewFlow: boolean }>()
);

export const leaveQuestionnaire = createAction(`${prefix} Leave questionnaire`);

export const loadNextQuestion = createAction(
  `${prefix} Load next question`,
  props<{ question: SingleAnswerQuestion | OpenAnswerQuestion }>()
);

export const loadPreviousQuestion = createAction(
  `${prefix} Load previous question`
);

export const answerMappingError = createAction(
  `${prefix} Error while mapping answer`
);

export const openInfoModal = createAction(
  `${prefix} Open info modal`,
  props<{ funnelKey: string }>()
);
